const paymentMethodMap = {
    Cash: "Cash",
    Visa: "Visa",
    Mastercard: "Mastercard",
    Amex: "American Express",
    Nets: "NETS",
    Paynow: "Pay Now",
    JCB: "JCB",
    Union: "Union Pay",
    TNG: "TNG",
    Duitnow: "Duit Now",
}

export default paymentMethodMap;